//import TextBookManageWordCoolPopup from "@/pages/comp/book_order/textbook/popup/manage_word_cool";
import TextBookManageWordCoolPopupArea from "@/pages/comp/book_order/textbook/common/popup/manage_word_cool";

function TextBookManageWordCoolPopup(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    g_par_id: "",
    g_par_seq: "",
    ...props
  };

  return (
    <div>
      <TextBookManageWordCoolPopupArea
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        callbackData={myProps.callbackData}
        g_par_id={myProps.g_par_id}
        g_par_seq={myProps.g_par_seq}
      ></TextBookManageWordCoolPopupArea>
    </div>
  );
};
export default TextBookManageWordCoolPopup;